import React from "react";
import PageHeader from "../Components/common/PageHeader";
import YuzeyTemizlikMaddesi from "../Components/product/YuzeyTemizlikMaddesi";
import ProductSEO from "../Components/common/ProductSEO";

function YuzeyTemizlikMaddesiPage() {
    return (
        <>
            <ProductSEO
                name="Yüzey Temizlik Maddesi (Alkol Bazlı)"
                description="Hızlı kuruyan alkol bazlı formül ile etkili yüzey temizliği ve hijyen."
                slug="yuzeytemizlikmaddesi"
                imagePath="assets/images/20-kg/10.webp"
            />
            <PageHeader title="Yüzey Temizlik Maddesi (Alkol Bazlı)" />
            <YuzeyTemizlikMaddesi />
        </>
    );
}

export default YuzeyTemizlikMaddesiPage;